// network-status.service.ts
import { Injectable, Signal, computed, effect, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, merge, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private readonly isOnlineSignal = signal(navigator.onLine);

  constructor(private http: HttpClient) {
    this.setupListeners();
  }

  private setupListeners() {
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));

    merge(online$, offline$).subscribe((status) => {
      this.isOnlineSignal.set(status);
    });
  }

  /** Signal that updates when browser reports online/offline */
  get online(): Signal<boolean> {
    return this.isOnlineSignal.asReadonly();
  }

  /** Optional: Check real internet connectivity (ping server) */
  async checkInternetConnection(pingUrl = '/assets/ping.json'): Promise<boolean> {
    try {
      await this.http.get(pingUrl, { responseType: 'text' }).toPromise();
      return true;
    } catch {
      return false;
    }
  }
}
